
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import "../../../assets/css/cards.scss"
import { CardsContent, ILandingSection, SECTION_DESIGN_TYPE } from "../../../data/interfaces"
import CardAccordeon from "./cards/CardAccordeon"
import CardHaccordeon from "./cards/CardHaccordeon"
import CardsCarousel from "./cards/CardsCarousel"
import CardsList from "./cards/CardsList"
import CardsVerticalTimeLine from "./cards/CardsVerticalTimeLine"
import CardsHorizontalTimeLine from "./cards/CardsHorizontalTimeLine"

/* Protopia Ecosystem component */
export interface ICardsProps {
    section: ILandingSection
    data: CardsContent 
}
const Cards = ( props: ICardsProps): JSX.Element => { 
    const sizes = useScreenSize()
    switch(props.data.feedType) {        
        case SECTION_DESIGN_TYPE.HTIMELINE:                 // use ITimelineCard
            return <CardsHorizontalTimeLine {...props } />       
        case SECTION_DESIGN_TYPE.VTIMELINE:                 // use ITimelineCard
            return <CardsVerticalTimeLine {...props } />       
        case SECTION_DESIGN_TYPE.HACCORDEON:
            return sizes.width > WINDOW_WIDTH.TABLET        // use ITimelineCard
                ?
                <CardHaccordeon {...props } />
                :
                <CardsList {...props } />        
        case SECTION_DESIGN_TYPE.ACCORDEON:
            return sizes.width > WINDOW_WIDTH.TABLET        // use ICard
                ?
                <CardAccordeon {...props } />
                :
                <CardsList {...props } />        
        case SECTION_DESIGN_TYPE.VERTICAL_CAROUSEL:                  // use ICard
        case SECTION_DESIGN_TYPE.CAROUSEL:                  // use ICard
            return <CardsCarousel {...props } />        
        case SECTION_DESIGN_TYPE.FEED:                      // use ICard
        case SECTION_DESIGN_TYPE.COLUMN:                    // use ICard
        default:
            return <CardsList {...props } />
    }
}
export default Cards